import { FC } from 'react';
import { CenterModalProps } from './centerModal.type';
import Close from '../../assets/close.png';
import FooterButton from '../button/button';
import ButtonSpinner from '../../assets/buttonLoading/buttonLoading';
import { Trans } from 'react-i18next';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'center-modal';
const CenterModal: FC<CenterModalProps> = (props) => {
  if (!props.isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
      {...getIdAttributes(idPrefix, 'overlay')}
    >
      <div
        {...getIdAttributes(idPrefix, 'container')}
        className={`bg-white rounded-xl w-full relative p-8 max-w-xl
        `}
        style={{ boxShadow: '-10px 0px 50px #2F41A51F' }}
      >
        {/* Header */}
        {!props.showSuccess &&
          (props.showCenterHeader ? (
            <div
              className="relative"
              {...getIdAttributes(idPrefix, 'header-center')}
            >
              <img
                onClick={props.onClose}
                src={Close}
                alt="Close"
                className="w-4 h-4 cursor-pointer absolute top-0 right-4"
                {...getIdAttributes(idPrefix, 'close-btn')}
              />
              <br />
              <div
                className="text-lg font-semibold text-center"
                {...getIdAttributes('center-modal', 'title')}
              >
                <Trans i18nKey={props.title} />
              </div>
            </div>
          ) : (
            <div className="flex items-center justify-between border-b pb-6">
              <h2
                className="text-lg font-semibold"
                {...getIdAttributes('center-modal', 'title')}
              >
                <Trans i18nKey={props.title} />
              </h2>
              <img
                onClick={props.onClose}
                src={Close}
                alt="Close"
                className="w-4 h-4 cursor-pointer"
                {...getIdAttributes(idPrefix, 'close-btn')}
              />
            </div>
          ))}

        {/* modal content */}
        <div className="pb-4" {...getIdAttributes(idPrefix, 'content')}>
          {props.children}
        </div>

        {/* Footer */}
        <div
          className={`flex pt-3 gap-2 ${
            props.showClearButton ? 'justify-center' : 'justify-between'
          }`}
          {...getIdAttributes(idPrefix, 'footer')}
        >
          {!props.showClearButton && (
            <FooterButton
              className="w-28 py-2 rounded-full bg-white border text-[#A7A7A7] text-sm border-[#D8D8D8] hover:bg-white hover:text-[#A7A7A7]"
              onClick={props.onClear}
              {...getIdAttributes(idPrefix, 'clear-btn')}
            >
              <Trans i18nKey={props.clearText} />
            </FooterButton>
          )}

          <FooterButton
            className={`w-28 py-2 rounded-full text-sm 
          ${
            props.isDisabled
              ? 'bg-THEME_DISABLE_COLOR text-THEME_DISABLE_TEXT_COLOR cursor-not-allowed'
              : 'bg-THEME_COLOR text-white hover:bg-THEME_HOVER_COLOR'
          }`}
            onClick={props.onSubmit}
            disabled={props.isDisabled}
            {...getIdAttributes(idPrefix, 'submit-btn')}
          >
            {props.isLoading ? (
              <ButtonSpinner />
            ) : (
              <Trans i18nKey={props.successText} />
            )}
          </FooterButton>
        </div>
      </div>
    </div>
  );
};

export default CenterModal;
